import { analyzeImageFromArrayBuffer, type ProcessedImage } from "@nova-rnd/sensortool-wasm"
import { defineTask } from "@nova/webworker-pool"
import { initializeSensorToolFromModule } from "integrations/sensortool"

const thermalTiffWidthPx = 1024
const thermalTiffHeightPx = 768

export const convertImageToTiff = defineTask({
    name: "convertImageToTiff",
    wasm: ["sensortool"],
    run: async (
        { fileBuffer, xmlFileBuffer }: { fileBuffer: ArrayBuffer; xmlFileBuffer?: ArrayBuffer },
        { wasm }
    ) => {
        initializeSensorToolFromModule(wasm.sensortool)
        let processedImage: ProcessedImage | undefined
        try {
            processedImage = await analyzeImageFromArrayBuffer(fileBuffer)
            if (xmlFileBuffer) processedImage.addTelemetryFromArrayBuffer(xmlFileBuffer)
            return {
                data: {
                    tiff: processedImage.getThermalTiff(thermalTiffWidthPx, thermalTiffHeightPx),
                },
            }
        } finally {
            processedImage?.free()
        }
    },
})
